import { FC, useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { getRefundedOrdersTodo } from '../../../api/refunds.api';
import useAxios from '../../../hooks/useAxios';
import { IGetRefundedOrdersTodo } from '../../../models/refunds.model';
import { IStudent } from '../../../models/students.model';
import ErrorResponse from '../../ErrorResponse';
import Loader from '../../Loader';
import Radio from '../../Radio';
import StudentName from './Name';
import RefundHistory from './RefundHistory';
import RefundTarget from './RefundTarget';

interface IProps {
  student: IStudent | undefined;
}

export enum RefundContents {
  RefundTarget,
  RefundHistory,
}

const StudentRefund: FC<IProps> = ({
                                     student,
                                   }) => {
  const { t } = useTranslation();
  const { data: res, isLoading, error, execute } = useAxios<IGetRefundedOrdersTodo>();

  const [content, setContent] = useState<RefundContents>(RefundContents.RefundTarget);

  useEffect(() => {
    if (student) {
      doGetRefundedOrdersTodo();
    }
  }, [student]);

  const doGetRefundedOrdersTodo = () => {
    if (!student) return;
    execute(getRefundedOrdersTodo(student.studentCode));
  };

  const renderContent = () => {
    switch (content) {
      case RefundContents.RefundTarget:
        return (
          <RefundTarget
            memberCode={student?.studentCode}
            data={
              res?.data?.filter(item => item.refundSttCode === 'WA')
            }
            doGetRefundedOrdersTodo={doGetRefundedOrdersTodo}
          />
        );
      case RefundContents.RefundHistory:
        return (
          <RefundHistory
            data={
              res?.data?.filter(
                item => item.refundSttCode === 'SU' ||
                  item.refundSttCode === 'FI',
              )}
            doGetRefundedOrdersTodo={doGetRefundedOrdersTodo}
          />
        );
    }
  };

  return (
    <>
      {isLoading ? <Loader /> : null}
      <ErrorResponse error={error} />

      <StudentName student={student} />

      <div className="comm-bx__space">
        <div className="comm-btn__area right">
          <Radio
            checked={content === RefundContents.RefundTarget}
            onChange={() => setContent(RefundContents.RefundTarget)}
            text={t('student.student.option27')}
          />
          <Radio
            className="ml-1"
            checked={content === RefundContents.RefundHistory}
            onChange={() => setContent(RefundContents.RefundHistory)}
            text={t('student.student.option28')}
          />
        </div>
      </div>
      {renderContent()}
    </>
  );
};

export default StudentRefund;